import { useFirestoreDocumentData } from "@react-query-firebase/firestore";
import { auth, firestore } from "../firebase";
import {
	collection,
	doc,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import {useEffect} from "react";
import OneSignal from "react-onesignal";
export default function useFirestoreDocument (docName) {
    const [user] = useAuthState(auth);

	const collectionRef = collection(firestore, docName);
    const ref = doc(collectionRef, user?.uid || "a");

	const getDocument = useFirestoreDocumentData([docName, user?.uid], ref, {subscribe: true}, {enabled: !!user?.uid});

    useEffect(() => {

        OneSignal
            .setExternalUserId(user?.uid, getDocument?.data?.one_signal_identifier_hash)
            .then(() => {
                window.OneSignal.push(() => {
                    if (getDocument?.data?.email_hash) {
                        OneSignal.setEmail(getDocument?.data?.email, {
                            emailAuthHash: getDocument?.data?.email_hash
                        })
                    }
                    if (getDocument.data?.phone_hash) {
                        OneSignal.setSMSNumber(user.phoneNumber, {identifierAuthHash: getDocument.data?.phone_hash})
                    }
                })
            })
    }, [getDocument?.data?.one_signal_identifier_hash, getDocument?.data?.email_hash, getDocument?.data?.phone_hash])

    //email hash

    //getDocument?.data?.one_signal_identifier_hash

  return {
    getDocument,
  }
}
